import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { AggregateBusinessMemoAggregateBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計情報のメモを追加/修正する
 */
export class PutAggregateBusinessMemoUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 集計情報のリポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * メモを追加/変更する
   * @param aggregateBusinessId - 集計ID
   * @param memoText - メモの本文
   */
  public async Execute(aggregateBusinessId: string, memoText: string): Promise<INetworkResult<string, Error>> {
    const request: AggregateBusinessMemoAggregateBusinessIdPutRequest = { aggregateBusinessMemoInfo: { memoText: memoText } };
    try {
      const result = await this.repository.putAggregateBusinessMemo(aggregateBusinessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: result.status.data,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
